// src/portfolio.js

const portfolio = {
  // ========================
  // Header
  // ========================
  name: 'Omkar Indalkar',
  title: "Backend Engineer | Java • Spring Boot • Cloud",
  // ========================
  // About
  // ========================
  description:
    "Passionate backend developer trained in Java, Spring Boot, and Kafka. Experienced in building REST APIs and scalable enterprise systems. CGPA 8.3/10 MIT-WPU. Open to new opportunities and collaboration.",
  // ========================
  // Personal Info & Socials
  // ========================
  contact: [
    {
      type: 'Email',
      text: 'indalkaromkar97@gmail.com',
      href: 'mailto:omkarindalkar.9@gmail.com'
    },
    {
      type: 'Phone',
      text: '7499067336'
    },
    {
      type: 'GitHub',
      text: 'github.com/indalkaromkar',
      href: 'https://github.com/indalkaromkar'
    },
    {
      type: 'LinkedIn',
      text: 'linkedin.com/in/omkar-indalkar-5744ba203',
      href: 'https://linkedin.com/in/omkar-indalkar-5744ba203'
    },
  ],
  // ========================
  // Skills
  // ========================
  skills: [
    'Java',
    'C++',
    'HTML/CSS',
    'JavaScript',
    'TypeScript',
    'ReactJS',
    'Node.js',
    'REST APIs',
    'C',
    'MySQL',
    'Python',
    'Spring Boot',
    'Kafka',
    'Git',
    'Postman',
  ],
  // ========================
  // Education
  // ========================
  education: [
    {
      degree: 'BTech in Computer Engineering',
      place: 'MIT WPU',
      startDate: 'July 2022',
      endDate: 'May 2025',
      gpa: 'CGPA: 8.3/10',
    },
    {
      degree: 'Diploma in Computer Engineering',
      place: 'MIT WPU',
      startDate: 'July 2019',
      endDate: 'May 2022',
      gpa: 'CGPA: 9.2/10',
    }
  ],
  // ========================
  // Experience
  // ========================
  experience: [
    {
      title: 'SDE Intern',
      company: "StarHealth",
      location: "City, State",
      startDate: "Jan 2025",
      endDate: "June 2025",
      details: [
        "Assisted in solving SonarQube issues and wrote JUnit5 and Mockito unit test cases.",
        "Developed REST APIs in Java Spring Boot.",
        "Collaborated to integrate Kafka event systems for automated workflows.",
        "Built an internal system to record workflow stages in a database."
      ]
    },
    {
      title: 'Intern',
      company: "CodeGurukul",
      location: "City, State",
      startDate: "May 2021",
      endDate: "Aug 2021",
      details: [
        "Redesigned UI/UX for core applications.",
        "Automated customer feedback storage in the database.",
        "Implemented report visualization using HTML, JavaScript, and CSS."
      ]
    }
  ],
  // ========================
  // Projects (Add more below as needed)
  // ========================
  projects: [
    {
      name: 'E-Commerce Backend (Spring Microservices)',
      description:
        'Modular e-commerce backend with Java, Spring Boot, Spring Cloud, REST APIs, authentication, and order management.',
      stack: ['Java', 'Spring Boot', 'Spring Cloud', 'MySQL', 'Docker'],
      live: '',
      source: 'https://github.com/indalkaromkar/E-Commerce-Backend-Spring-Microservices'
    },
    {
      name: 'Bank Application REST API',
      description:
        'Core banking APIs for account, customer, and transaction management, using relational DB for persistence.',
      stack: ['Java', 'Spring Boot', 'MySQL'],
      live: '',
      source: 'https://github.com/indalkaromkar/bank-application-rest-api'
    },
    {
      name: 'Event Driven Spring Boot Kafka',
      description:
        'Event-driven microservices demonstration for pub-sub pattern using Apache Kafka.',
      stack: ['Java', 'Spring Boot', 'Kafka'],
      live: '',
      source: 'https://github.com/indalkaromkar/event-driven-spring-boot-kafka'
    },
    {
      name: 'Netflix Clone',
      description: 'Frontend project mimicking Netflix UI with TMDB API.',
      stack: ['JavaScript', 'ReactJS', 'TMDB API'],
      live: '',
      source: 'https://github.com/indalkaromkar/netflix-clone'
    },
    {
      name: 'Spring Boot Microservices Playground',
      description: 'Examples of containerized, event-driven, and circuit-breaker microservices.',
      stack: ['Java', 'Spring Boot', 'Docker'],
      live: '',
      source: 'https://github.com/indalkaromkar/spring-boot-microservices'
    },
    {
      name: 'Starter Blog',
      description: 'Minimal TypeScript/Next.js static blog platform.',
      stack: ['TypeScript', 'Next.js'],
      live: '',
      source: 'https://github.com/indalkaromkar/starter-blog'
    },
    {
      name: 'Apple Quality Detection',
      description:
        'Deep Learning model classifying apples as fresh or rotten (accuracy ~96%). Background preprocessing and model evaluation (TensorFlow, scikit-learn).',
      stack: ['Python', 'TensorFlow', 'scikit-learn'],
      live: '',
      source: ''
    },
    {
      name: 'Bank Debit Integration (StarHealth)',
      description:
        'Automated policy bank debit system using event-driven microservices and Kafka; API wrappers for internal/external communication.',
      stack: ['Java', 'Spring Boot', 'Kafka'],
      live: '',
      source: ''
    }
  ],
  // ========================
  // Achievements / Certifications
  // ========================
  achievements: [
    'Completed “National Academic Immersion Program” in AI/ML at Bangalore, certified by Siemens Pvt. Ltd.'
  ]
};

export default portfolio;
